//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import ClientBase from "./client.base";

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IClient {
  /**
   * @return OK
   */
  apiV2ASWPActiveApplicationMessages(): Promise<ApplicationMessageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2Booking(
    body: CreateBookingRequest | undefined
  ): Promise<CreateBookingResponse>;

  /**
   * @param proposalId (optional)
   * @return OK
   */
  apiV2BusinessProposalGetBusinessProposal(
    proposalId: string | undefined
  ): Promise<BusinessProposalResponse>;

  /**
   * @param proposalId (optional)
   * @return OK
   */
  apiV2BusinessProposalMarkProposalAsRead(
    proposalId: string | undefined
  ): Promise<void>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2BusinessProposalRejectBusinessProposal(
    body: RejectBusinessProposalRequest | undefined
  ): Promise<void>;

  /**
   * @param orchestrated (optional)
   * @param body (optional)
   * @return OK
   */
  apiV2CalendarAvailableTimeSlots(
    orchestrated: string | undefined,
    body: AvailableTimeSlotsRequest | undefined
  ): Promise<CalendarDayTimeSlotResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2DealerGetAll(body: DealerRequest | undefined): Promise<DealerResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2DealerGetCampaignCode(
    body: CampaignByCodeRequest | undefined
  ): Promise<CampaignResponse>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2DealerExternalTyre(
    body: ExternalTyreUrlRequest | undefined
  ): Promise<ExternalTyreUrlResponse>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2DealerWorkshopBookingFindBookings(
    body: FindBookingsV2Request[] | undefined
  ): Promise<FindBookingV2Response[]>;

  /**
   * @param dealerNumber (optional)
   * @param date (optional)
   * @param startTime (optional)
   * @param endTime (optional)
   * @return OK
   */
  apiV2EuropcarAvailableCars(
    dealerNumber: string | undefined,
    date: string | undefined,
    startTime: string | undefined,
    endTime: string | undefined
  ): Promise<EbuCarModelResponse[]>;

  /**
   * @return OK
   * @deprecated
   */
  apiV2Image(chassiNumber: string, fileName: string): Promise<string>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2InsuranceCompanyActiveInsuranceCompanies(
    body: InsuranceCompanyRequest | undefined
  ): Promise<InsuranceCompanyResponse[]>;

  /**
   * @return OK
   */
  apiV2MediaGet(fileId: string): Promise<void>;

  /**
   * @return OK
   */
  apiV2MediaByVin(vin: string, fileId: string): Promise<void>;

  /**
   * @param mediaType (optional)
   * @param vin (optional)
   * @param file (optional)
   * @return OK
   */
  apiV2MediaPost(
    mediaType: MediaTypeEnum | undefined,
    vin: string | undefined,
    file: FileParameter | undefined
  ): Promise<string>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageBaseServiceSuggestions(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageOriginalService(
    body: PackageRequest | undefined
  ): Promise<PackageResponse>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageDetermineServiceType(
    body: PackageRequest | undefined
  ): Promise<PackageTypeEnum[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageTroubleshooting(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageWindshield(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageWheel(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageTechUpdate(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageDealerExtra(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageGetFilteredPackages(
    body: FilteredPackagesRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageServiceAdditional(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageMobility(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageDropOffOption(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageWashAndRecond(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageAll(body: PackageRequest | undefined): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackagePPSAll(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2VehicleSearch(
    body: VehicleSearchRequest | undefined
  ): Promise<VehicleSearchResponse>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2VehicleGetSegment(
    body: VehicleSegmentRequest | undefined
  ): Promise<number>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2VehicleGetTechUpdateStatus(
    body: GetTechUpdateStatusRequest | undefined
  ): Promise<GetTechUpdateStatusResponse>;

  /**
   * @return OK
   */
  apiV2VehicleAllWarningLights(): Promise<VehicleWarningLightsResponse[]>;

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2WorkshopSystemActiveWorkshops(
    body: VehicleChassiRequest | undefined
  ): Promise<ActiveWorkshopSystemResponse[]>;
}

export class Client extends ClientBase implements IClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl("", baseUrl);
  }

  /**
   * @return OK
   */
  apiV2ASWPActiveApplicationMessages(): Promise<ApplicationMessageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/ASWP/ActiveApplicationMessagesAsync";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2ASWPActiveApplicationMessages(_response);
    });
  }

  protected processApiV2ASWPActiveApplicationMessages(
    response: Response
  ): Promise<ApplicationMessageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ApplicationMessageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ApplicationMessageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2Booking(
    body: CreateBookingRequest | undefined
  ): Promise<CreateBookingResponse> {
    let url_ = this.baseUrl + "/api/v2/Booking";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2Booking(_response);
    });
  }

  protected processApiV2Booking(
    response: Response
  ): Promise<CreateBookingResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CreateBookingResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        let result400: any = null;
        let resultData400 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = CreateBookingErrorResponse.fromJS(resultData400);
        return throwException(
          "Bad Request",
          status,
          _responseText,
          _headers,
          result400
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CreateBookingResponse>(null as any);
  }

  /**
   * @param proposalId (optional)
   * @return OK
   */
  apiV2BusinessProposalGetBusinessProposal(
    proposalId: string | undefined
  ): Promise<BusinessProposalResponse> {
    let url_ = this.baseUrl + "/api/v2/BusinessProposal/GetBusinessProposal?";
    if (proposalId === null)
      throw new globalThis.Error("The parameter 'proposalId' cannot be null.");
    else if (proposalId !== undefined)
      url_ += "proposalId=" + encodeURIComponent("" + proposalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2BusinessProposalGetBusinessProposal(_response);
    });
  }

  protected processApiV2BusinessProposalGetBusinessProposal(
    response: Response
  ): Promise<BusinessProposalResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = BusinessProposalResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Not Found", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<BusinessProposalResponse>(null as any);
  }

  /**
   * @param proposalId (optional)
   * @return OK
   */
  apiV2BusinessProposalMarkProposalAsRead(
    proposalId: string | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/BusinessProposal/MarkProposalAsRead?";
    if (proposalId === null)
      throw new globalThis.Error("The parameter 'proposalId' cannot be null.");
    else if (proposalId !== undefined)
      url_ += "proposalId=" + encodeURIComponent("" + proposalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2BusinessProposalMarkProposalAsRead(_response);
    });
  }

  protected processApiV2BusinessProposalMarkProposalAsRead(
    response: Response
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Not Found", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2BusinessProposalRejectBusinessProposal(
    body: RejectBusinessProposalRequest | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/BusinessProposal/RejectBusinessProposal";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2BusinessProposalRejectBusinessProposal(_response);
    });
  }

  protected processApiV2BusinessProposalRejectBusinessProposal(
    response: Response
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Not Found", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param orchestrated (optional)
   * @param body (optional)
   * @return OK
   */
  apiV2CalendarAvailableTimeSlots(
    orchestrated: string | undefined,
    body: AvailableTimeSlotsRequest | undefined
  ): Promise<CalendarDayTimeSlotResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Calendar/AvailableTimeSlots?";
    if (orchestrated === null)
      throw new globalThis.Error(
        "The parameter 'orchestrated' cannot be null."
      );
    else if (orchestrated !== undefined)
      url_ += "orchestrated=" + encodeURIComponent("" + orchestrated) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2CalendarAvailableTimeSlots(_response);
    });
  }

  protected processApiV2CalendarAvailableTimeSlots(
    response: Response
  ): Promise<CalendarDayTimeSlotResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(CalendarDayTimeSlotResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CalendarDayTimeSlotResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2DealerGetAll(
    body: DealerRequest | undefined
  ): Promise<DealerResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Dealer/GetAll";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2DealerGetAll(_response);
    });
  }

  protected processApiV2DealerGetAll(
    response: Response
  ): Promise<DealerResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(DealerResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<DealerResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2DealerGetCampaignCode(
    body: CampaignByCodeRequest | undefined
  ): Promise<CampaignResponse> {
    let url_ = this.baseUrl + "/api/v2/Dealer/GetCampaignCode";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2DealerGetCampaignCode(_response);
    });
  }

  protected processApiV2DealerGetCampaignCode(
    response: Response
  ): Promise<CampaignResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CampaignResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Not Found", status, _responseText, _headers);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<CampaignResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2DealerExternalTyre(
    body: ExternalTyreUrlRequest | undefined
  ): Promise<ExternalTyreUrlResponse> {
    let url_ = this.baseUrl + "/api/v2/Dealer/ExternalTyre";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2DealerExternalTyre(_response);
    });
  }

  protected processApiV2DealerExternalTyre(
    response: Response
  ): Promise<ExternalTyreUrlResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ExternalTyreUrlResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ExternalTyreUrlResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2DealerWorkshopBookingFindBookings(
    body: FindBookingsV2Request[] | undefined
  ): Promise<FindBookingV2Response[]> {
    let url_ = this.baseUrl + "/api/v2/Dealer/Workshop/Booking/FindBookings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2DealerWorkshopBookingFindBookings(_response);
    });
  }

  protected processApiV2DealerWorkshopBookingFindBookings(
    response: Response
  ): Promise<FindBookingV2Response[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(FindBookingV2Response.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<FindBookingV2Response[]>(null as any);
  }

  /**
   * @param dealerNumber (optional)
   * @param date (optional)
   * @param startTime (optional)
   * @param endTime (optional)
   * @return OK
   */
  apiV2EuropcarAvailableCars(
    dealerNumber: string | undefined,
    date: string | undefined,
    startTime: string | undefined,
    endTime: string | undefined
  ): Promise<EbuCarModelResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Europcar/available-cars?";
    if (dealerNumber === null)
      throw new globalThis.Error(
        "The parameter 'dealerNumber' cannot be null."
      );
    else if (dealerNumber !== undefined)
      url_ += "dealerNumber=" + encodeURIComponent("" + dealerNumber) + "&";
    if (date === null)
      throw new globalThis.Error("The parameter 'date' cannot be null.");
    else if (date !== undefined)
      url_ += "date=" + encodeURIComponent("" + date) + "&";
    if (startTime === null)
      throw new globalThis.Error("The parameter 'startTime' cannot be null.");
    else if (startTime !== undefined)
      url_ += "startTime=" + encodeURIComponent("" + startTime) + "&";
    if (endTime === null)
      throw new globalThis.Error("The parameter 'endTime' cannot be null.");
    else if (endTime !== undefined)
      url_ += "endTime=" + encodeURIComponent("" + endTime) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2EuropcarAvailableCars(_response);
    });
  }

  protected processApiV2EuropcarAvailableCars(
    response: Response
  ): Promise<EbuCarModelResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(EbuCarModelResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException("Not Found", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<EbuCarModelResponse[]>(null as any);
  }

  /**
   * @return OK
   * @deprecated
   */
  apiV2Image(chassiNumber: string, fileName: string): Promise<string> {
    let url_ = this.baseUrl + "/api/v2/Image/{chassiNumber}/{fileName}";
    if (chassiNumber === undefined || chassiNumber === null)
      throw new globalThis.Error(
        "The parameter 'chassiNumber' must be defined."
      );
    url_ = url_.replace(
      "{chassiNumber}",
      encodeURIComponent("" + chassiNumber)
    );
    if (fileName === undefined || fileName === null)
      throw new globalThis.Error("The parameter 'fileName' must be defined.");
    url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2Image(_response);
    });
  }

  protected processApiV2Image(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : (null as any);

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2InsuranceCompanyActiveInsuranceCompanies(
    body: InsuranceCompanyRequest | undefined
  ): Promise<InsuranceCompanyResponse[]> {
    let url_ =
      this.baseUrl + "/api/v2/InsuranceCompany/ActiveInsuranceCompanies";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2InsuranceCompanyActiveInsuranceCompanies(
        _response
      );
    });
  }

  protected processApiV2InsuranceCompanyActiveInsuranceCompanies(
    response: Response
  ): Promise<InsuranceCompanyResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(InsuranceCompanyResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<InsuranceCompanyResponse[]>(null as any);
  }

  /**
   * @return OK
   */
  apiV2MediaGet(fileId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/Media/{fileId}";
    if (fileId === undefined || fileId === null)
      throw new globalThis.Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2MediaGet(_response);
    });
  }

  protected processApiV2MediaGet(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 206) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  apiV2MediaByVin(vin: string, fileId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v2/Media/byVin/{vin}/{fileId}";
    if (vin === undefined || vin === null)
      throw new globalThis.Error("The parameter 'vin' must be defined.");
    url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
    if (fileId === undefined || fileId === null)
      throw new globalThis.Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {}
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2MediaByVin(_response);
    });
  }

  protected processApiV2MediaByVin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 206) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          "Internal Server Error",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param mediaType (optional)
   * @param vin (optional)
   * @param file (optional)
   * @return OK
   */
  apiV2MediaPost(
    mediaType: MediaTypeEnum | undefined,
    vin: string | undefined,
    file: FileParameter | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v2/Media?";
    if (mediaType === null)
      throw new globalThis.Error("The parameter 'mediaType' cannot be null.");
    else if (mediaType !== undefined)
      url_ += "mediaType=" + encodeURIComponent("" + mediaType) + "&";
    if (vin === null)
      throw new globalThis.Error("The parameter 'vin' cannot be null.");
    else if (vin !== undefined)
      url_ += "vin=" + encodeURIComponent("" + vin) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file === null || file === undefined)
      throw new globalThis.Error("The parameter 'file' cannot be null.");
    else
      content_.append(
        "file",
        file.data,
        file.fileName ? file.fileName : "file"
      );

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        Accept: "text/plain"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2MediaPost(_response);
    });
  }

  protected processApiV2MediaPost(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : _responseText;
        result200 = resultData200 !== undefined ? resultData200 : (null as any);

        return result200;
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException("Bad Request", status, _responseText, _headers);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      });
    } else if (status === 415) {
      return response.text().then((_responseText) => {
        return throwException(
          "Unsupported Media Type",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageBaseServiceSuggestions(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/BaseServiceSuggestions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageBaseServiceSuggestions(_response);
    });
  }

  protected processApiV2PackageBaseServiceSuggestions(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageOriginalService(
    body: PackageRequest | undefined
  ): Promise<PackageResponse> {
    let url_ = this.baseUrl + "/api/v2/Package/OriginalService";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageOriginalService(_response);
    });
  }

  protected processApiV2PackageOriginalService(
    response: Response
  ): Promise<PackageResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PackageResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageDetermineServiceType(
    body: PackageRequest | undefined
  ): Promise<PackageTypeEnum[]> {
    let url_ = this.baseUrl + "/api/v2/Package/DetermineServiceType";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageDetermineServiceType(_response);
    });
  }

  protected processApiV2PackageDetermineServiceType(
    response: Response
  ): Promise<PackageTypeEnum[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(item);
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageTypeEnum[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageTroubleshooting(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/Troubleshooting";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageTroubleshooting(_response);
    });
  }

  protected processApiV2PackageTroubleshooting(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageWindshield(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/Windshield";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageWindshield(_response);
    });
  }

  protected processApiV2PackageWindshield(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageWheel(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/Wheel";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageWheel(_response);
    });
  }

  protected processApiV2PackageWheel(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageTechUpdate(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/TechUpdate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageTechUpdate(_response);
    });
  }

  protected processApiV2PackageTechUpdate(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageDealerExtra(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/DealerExtra";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageDealerExtra(_response);
    });
  }

  protected processApiV2PackageDealerExtra(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageGetFilteredPackages(
    body: FilteredPackagesRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/GetFilteredPackages";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageGetFilteredPackages(_response);
    });
  }

  protected processApiV2PackageGetFilteredPackages(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageServiceAdditional(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/ServiceAdditional";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageServiceAdditional(_response);
    });
  }

  protected processApiV2PackageServiceAdditional(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageMobility(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/Mobility";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageMobility(_response);
    });
  }

  protected processApiV2PackageMobility(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageDropOffOption(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/DropOffOption";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageDropOffOption(_response);
    });
  }

  protected processApiV2PackageDropOffOption(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageWashAndRecond(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/WashAndRecond";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageWashAndRecond(_response);
    });
  }

  protected processApiV2PackageWashAndRecond(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackageAll(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/All";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackageAll(_response);
    });
  }

  protected processApiV2PackageAll(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2PackagePPSAll(
    body: PackageRequest | undefined
  ): Promise<PackageResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Package/PPS/All";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2PackagePPSAll(_response);
    });
  }

  protected processApiV2PackagePPSAll(
    response: Response
  ): Promise<PackageResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(PackageResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        let resultData404 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result404 = ErrorResponse.fromJS(resultData404);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<PackageResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2VehicleSearch(
    body: VehicleSearchRequest | undefined
  ): Promise<VehicleSearchResponse> {
    let url_ = this.baseUrl + "/api/v2/Vehicle/Search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2VehicleSearch(_response);
    });
  }

  protected processApiV2VehicleSearch(
    response: Response
  ): Promise<VehicleSearchResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = VehicleSearchResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleSearchResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2VehicleGetSegment(
    body: VehicleSegmentRequest | undefined
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v2/Vehicle/GetSegment";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2VehicleGetSegment(_response);
    });
  }

  protected processApiV2VehicleGetSegment(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : (null as any);

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2VehicleGetTechUpdateStatus(
    body: GetTechUpdateStatusRequest | undefined
  ): Promise<GetTechUpdateStatusResponse> {
    let url_ = this.baseUrl + "/api/v2/Vehicle/GetTechUpdateStatus";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2VehicleGetTechUpdateStatus(_response);
    });
  }

  protected processApiV2VehicleGetTechUpdateStatus(
    response: Response
  ): Promise<GetTechUpdateStatusResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetTechUpdateStatusResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<GetTechUpdateStatusResponse>(null as any);
  }

  /**
   * @return OK
   */
  apiV2VehicleAllWarningLights(): Promise<VehicleWarningLightsResponse[]> {
    let url_ = this.baseUrl + "/api/v2/Vehicle/AllWarningLights";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2VehicleAllWarningLights(_response);
    });
  }

  protected processApiV2VehicleAllWarningLights(
    response: Response
  ): Promise<VehicleWarningLightsResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(VehicleWarningLightsResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<VehicleWarningLightsResponse[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  apiV2WorkshopSystemActiveWorkshops(
    body: VehicleChassiRequest | undefined
  ): Promise<ActiveWorkshopSystemResponse[]> {
    let url_ = this.baseUrl + "/api/v2/WorkshopSystem/ActiveWorkshops";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processApiV2WorkshopSystemActiveWorkshops(_response);
    });
  }

  protected processApiV2WorkshopSystemActiveWorkshops(
    response: Response
  ): Promise<ActiveWorkshopSystemResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 =
          _responseText === ""
            ? null
            : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200)
            result200!.push(ActiveWorkshopSystemResponse.fromJS(item));
        } else {
          result200 = null as any;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ActiveWorkshopSystemResponse[]>(null as any);
  }
}

export enum MediaTypeEnum {
  Video = "Video",
  Image = "Image",
  Note = "Note"
}

export class CampaignResponse implements ICampaignResponse {
  campaignId?: number;
  name?: string | undefined;
  dealerNo?: string | undefined;
  discount?: number;
  discountType?: DiscountTypeEnum;
  startDate?: Date;
  endDate?: Date;
  description?: string | undefined;
  brand?: BrandCodeEnum | undefined;
  type?: CampaignTypeEnum;

  constructor(data?: ICampaignResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.campaignId = _data["campaignId"];
      this.name = _data["name"];
      this.dealerNo = _data["dealerNo"];
      this.discount = _data["discount"];
      this.discountType = _data["discountType"];
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : (undefined as any);
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : (undefined as any);
      this.description = _data["description"];
      this.brand = _data["brand"];
      this.type = _data["type"];
    }
  }

  static fromJS(data: any): CampaignResponse {
    data = typeof data === "object" ? data : {};
    let result = new CampaignResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["campaignId"] = this.campaignId;
    data["name"] = this.name;
    data["dealerNo"] = this.dealerNo;
    data["discount"] = this.discount;
    data["discountType"] = this.discountType;
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : (undefined as any);
    data["endDate"] = this.endDate
      ? this.endDate.toISOString()
      : (undefined as any);
    data["description"] = this.description;
    data["brand"] = this.brand;
    data["type"] = this.type;
    return data;
  }
}

export interface ICampaignResponse {
  campaignId?: number;
  name?: string | undefined;
  dealerNo?: string | undefined;
  discount?: number;
  discountType?: DiscountTypeEnum;
  startDate?: Date;
  endDate?: Date;
  description?: string | undefined;
  brand?: BrandCodeEnum | undefined;
  type?: CampaignTypeEnum;
}

export class DealerPropertyResponse implements IDealerPropertyResponse {
  dealerPropertyTypeId?: DealerPropertyTypeEnum;
  value?: string | undefined;
  dealerPropertyId?: DealerPropertyEnum;
  isActive?: boolean;
  dealerPropertyGroupId?: DealerPropertyGroupEnum;

  constructor(data?: IDealerPropertyResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealerPropertyTypeId = _data["dealerPropertyTypeId"];
      this.value = _data["value"];
      this.dealerPropertyId = _data["dealerPropertyId"];
      this.isActive = _data["isActive"];
      this.dealerPropertyGroupId = _data["dealerPropertyGroupId"];
    }
  }

  static fromJS(data: any): DealerPropertyResponse {
    data = typeof data === "object" ? data : {};
    let result = new DealerPropertyResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealerPropertyTypeId"] = this.dealerPropertyTypeId;
    data["value"] = this.value;
    data["dealerPropertyId"] = this.dealerPropertyId;
    data["isActive"] = this.isActive;
    data["dealerPropertyGroupId"] = this.dealerPropertyGroupId;
    return data;
  }
}

export interface IDealerPropertyResponse {
  dealerPropertyTypeId?: DealerPropertyTypeEnum;
  value?: string | undefined;
  dealerPropertyId?: DealerPropertyEnum;
  isActive?: boolean;
  dealerPropertyGroupId?: DealerPropertyGroupEnum;
}

export class ErrorResponse implements IErrorResponse {
  errorCode?: string | undefined;
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IErrorResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.errorCode = _data["errorCode"];
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ErrorResponse {
    data = typeof data === "object" ? data : {};
    let result = new ErrorResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["errorCode"] = this.errorCode;
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IErrorResponse {
  errorCode?: string | undefined;
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class AvailableTimeSlotsRequest implements IAvailableTimeSlotsRequest {
  dealerNumber!: string;
  chassiNumber!: string;
  odometer!: number;
  selectedPackages?: SelectedPackagesRequest[] | undefined;

  constructor(data?: IAvailableTimeSlotsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealerNumber = _data["dealerNumber"];
      this.chassiNumber = _data["chassiNumber"];
      this.odometer = _data["odometer"];
      if (Array.isArray(_data["selectedPackages"])) {
        this.selectedPackages = [] as any;
        for (let item of _data["selectedPackages"])
          this.selectedPackages!.push(SelectedPackagesRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AvailableTimeSlotsRequest {
    data = typeof data === "object" ? data : {};
    let result = new AvailableTimeSlotsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealerNumber"] = this.dealerNumber;
    data["chassiNumber"] = this.chassiNumber;
    data["odometer"] = this.odometer;
    if (Array.isArray(this.selectedPackages)) {
      data["selectedPackages"] = [];
      for (let item of this.selectedPackages)
        data["selectedPackages"].push(
          item ? item.toJSON() : (undefined as any)
        );
    }
    return data;
  }
}

export interface IAvailableTimeSlotsRequest {
  dealerNumber: string;
  chassiNumber: string;
  odometer: number;
  selectedPackages?: SelectedPackagesRequest[] | undefined;
}

export class BookingCustomerRequest implements IBookingCustomerRequest {
  firstName!: string;
  lastName!: string;
  phone?: string | undefined;
  email!: string;
  message?: string | undefined;
  sendSms?: boolean;

  constructor(data?: IBookingCustomerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phone = _data["phone"];
      this.email = _data["email"];
      this.message = _data["message"];
      this.sendSms = _data["sendSms"];
    }
  }

  static fromJS(data: any): BookingCustomerRequest {
    data = typeof data === "object" ? data : {};
    let result = new BookingCustomerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phone"] = this.phone;
    data["email"] = this.email;
    data["message"] = this.message;
    data["sendSms"] = this.sendSms;
    return data;
  }
}

export interface IBookingCustomerRequest {
  firstName: string;
  lastName: string;
  phone?: string | undefined;
  email: string;
  message?: string | undefined;
  sendSms?: boolean;
}

export class BookingDamageReportRequest implements IBookingDamageReportRequest {
  insuranceCompanyId?: number;
  damageDate?: Date | undefined;
  location?: string | undefined;
  reason?: string | undefined;
  description?: string | undefined;

  constructor(data?: IBookingDamageReportRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.insuranceCompanyId = _data["insuranceCompanyId"];
      this.damageDate = _data["damageDate"]
        ? new Date(_data["damageDate"].toString())
        : (undefined as any);
      this.location = _data["location"];
      this.reason = _data["reason"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): BookingDamageReportRequest {
    data = typeof data === "object" ? data : {};
    let result = new BookingDamageReportRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["insuranceCompanyId"] = this.insuranceCompanyId;
    data["damageDate"] = this.damageDate
      ? this.damageDate.toISOString()
      : (undefined as any);
    data["location"] = this.location;
    data["reason"] = this.reason;
    data["description"] = this.description;
    return data;
  }
}

export interface IBookingDamageReportRequest {
  insuranceCompanyId?: number;
  damageDate?: Date | undefined;
  location?: string | undefined;
  reason?: string | undefined;
  description?: string | undefined;
}

export class BookingResourceRequest implements IBookingResourceRequest {
  resourceGroupId?: string | undefined;
  date?: string;
  startDateTime?: Date | undefined;
  endDateTime?: Date | undefined;
  customerAllowedToWait?: boolean;
  usesTimeSlot?: boolean;

  constructor(data?: IBookingResourceRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.resourceGroupId = _data["resourceGroupId"];
      this.date = _data["date"];
      this.startDateTime = _data["startDateTime"]
        ? new Date(_data["startDateTime"].toString())
        : (undefined as any);
      this.endDateTime = _data["endDateTime"]
        ? new Date(_data["endDateTime"].toString())
        : (undefined as any);
      this.customerAllowedToWait = _data["customerAllowedToWait"];
      this.usesTimeSlot = _data["usesTimeSlot"];
    }
  }

  static fromJS(data: any): BookingResourceRequest {
    data = typeof data === "object" ? data : {};
    let result = new BookingResourceRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["resourceGroupId"] = this.resourceGroupId;
    data["date"] = this.date;
    data["startDateTime"] = this.startDateTime
      ? this.startDateTime.toISOString()
      : (undefined as any);
    data["endDateTime"] = this.endDateTime
      ? this.endDateTime.toISOString()
      : (undefined as any);
    data["customerAllowedToWait"] = this.customerAllowedToWait;
    data["usesTimeSlot"] = this.usesTimeSlot;
    return data;
  }
}

export interface IBookingResourceRequest {
  resourceGroupId?: string | undefined;
  date?: string;
  startDateTime?: Date | undefined;
  endDateTime?: Date | undefined;
  customerAllowedToWait?: boolean;
  usesTimeSlot?: boolean;
}

export class CreateBookingRequest implements ICreateBookingRequest {
  chassiNumber!: string;
  odometer!: number;
  dealerNumber!: string;
  time!: Date;
  usesTimeSlot!: boolean;
  bookingCustomer!: BookingCustomerRequest;
  ebuBooking?: EbuBookingRequest | undefined;
  campaignCode?: string | undefined;
  fileIds?: string[] | undefined;
  bookingDamageReport?: BookingDamageReportRequest | undefined;
  bookingResource?: BookingResourceRequest | undefined;
  selectedPackages?: SelectedPackagesRequest[] | undefined;
  warningLightIds?: number[] | undefined;
  customerMessage?: string | undefined;
  troubleShootingMessage?: string | undefined;
  successfulRecallCheck?: boolean;
  businessProposalId?: string | undefined;

  constructor(data?: ICreateBookingRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.bookingCustomer = new BookingCustomerRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.chassiNumber = _data["chassiNumber"];
      this.odometer = _data["odometer"];
      this.dealerNumber = _data["dealerNumber"];
      this.time = _data["time"]
        ? new Date(_data["time"].toString())
        : (undefined as any);
      this.usesTimeSlot = _data["usesTimeSlot"];
      this.bookingCustomer = _data["bookingCustomer"]
        ? BookingCustomerRequest.fromJS(_data["bookingCustomer"])
        : new BookingCustomerRequest();
      this.ebuBooking = _data["ebuBooking"]
        ? EbuBookingRequest.fromJS(_data["ebuBooking"])
        : (undefined as any);
      this.campaignCode = _data["campaignCode"];
      if (Array.isArray(_data["fileIds"])) {
        this.fileIds = [] as any;
        for (let item of _data["fileIds"]) this.fileIds!.push(item);
      }
      this.bookingDamageReport = _data["bookingDamageReport"]
        ? BookingDamageReportRequest.fromJS(_data["bookingDamageReport"])
        : (undefined as any);
      this.bookingResource = _data["bookingResource"]
        ? BookingResourceRequest.fromJS(_data["bookingResource"])
        : (undefined as any);
      if (Array.isArray(_data["selectedPackages"])) {
        this.selectedPackages = [] as any;
        for (let item of _data["selectedPackages"])
          this.selectedPackages!.push(SelectedPackagesRequest.fromJS(item));
      }
      if (Array.isArray(_data["warningLightIds"])) {
        this.warningLightIds = [] as any;
        for (let item of _data["warningLightIds"])
          this.warningLightIds!.push(item);
      }
      this.customerMessage = _data["customerMessage"];
      this.troubleShootingMessage = _data["troubleShootingMessage"];
      this.successfulRecallCheck = _data["successfulRecallCheck"];
      this.businessProposalId = _data["businessProposalId"];
    }
  }

  static fromJS(data: any): CreateBookingRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateBookingRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["chassiNumber"] = this.chassiNumber;
    data["odometer"] = this.odometer;
    data["dealerNumber"] = this.dealerNumber;
    data["time"] = this.time ? this.time.toISOString() : (undefined as any);
    data["usesTimeSlot"] = this.usesTimeSlot;
    data["bookingCustomer"] = this.bookingCustomer
      ? this.bookingCustomer.toJSON()
      : (undefined as any);
    data["ebuBooking"] = this.ebuBooking
      ? this.ebuBooking.toJSON()
      : (undefined as any);
    data["campaignCode"] = this.campaignCode;
    if (Array.isArray(this.fileIds)) {
      data["fileIds"] = [];
      for (let item of this.fileIds) data["fileIds"].push(item);
    }
    data["bookingDamageReport"] = this.bookingDamageReport
      ? this.bookingDamageReport.toJSON()
      : (undefined as any);
    data["bookingResource"] = this.bookingResource
      ? this.bookingResource.toJSON()
      : (undefined as any);
    if (Array.isArray(this.selectedPackages)) {
      data["selectedPackages"] = [];
      for (let item of this.selectedPackages)
        data["selectedPackages"].push(
          item ? item.toJSON() : (undefined as any)
        );
    }
    if (Array.isArray(this.warningLightIds)) {
      data["warningLightIds"] = [];
      for (let item of this.warningLightIds) data["warningLightIds"].push(item);
    }
    data["customerMessage"] = this.customerMessage;
    data["troubleShootingMessage"] = this.troubleShootingMessage;
    data["successfulRecallCheck"] = this.successfulRecallCheck;
    data["businessProposalId"] = this.businessProposalId;
    return data;
  }
}

export interface ICreateBookingRequest {
  chassiNumber: string;
  odometer: number;
  dealerNumber: string;
  time: Date;
  usesTimeSlot: boolean;
  bookingCustomer: BookingCustomerRequest;
  ebuBooking?: EbuBookingRequest | undefined;
  campaignCode?: string | undefined;
  fileIds?: string[] | undefined;
  bookingDamageReport?: BookingDamageReportRequest | undefined;
  bookingResource?: BookingResourceRequest | undefined;
  selectedPackages?: SelectedPackagesRequest[] | undefined;
  warningLightIds?: number[] | undefined;
  customerMessage?: string | undefined;
  troubleShootingMessage?: string | undefined;
  successfulRecallCheck?: boolean;
  businessProposalId?: string | undefined;
}

export class EbuBookingRequest implements IEbuBookingRequest {
  carGroup!: string | undefined;
  priceExVat?: number | undefined;
  priceIncVat?: number | undefined;
  startDate?: Date | undefined;
  endDate?: Date | undefined;

  constructor(data?: IEbuBookingRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.carGroup = _data["carGroup"];
      this.priceExVat = _data["priceExVat"];
      this.priceIncVat = _data["priceIncVat"];
      this.startDate = _data["startDate"]
        ? new Date(_data["startDate"].toString())
        : (undefined as any);
      this.endDate = _data["endDate"]
        ? new Date(_data["endDate"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): EbuBookingRequest {
    data = typeof data === "object" ? data : {};
    let result = new EbuBookingRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["carGroup"] = this.carGroup;
    data["priceExVat"] = this.priceExVat;
    data["priceIncVat"] = this.priceIncVat;
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : (undefined as any);
    data["endDate"] = this.endDate
      ? this.endDate.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IEbuBookingRequest {
  carGroup: string | undefined;
  priceExVat?: number | undefined;
  priceIncVat?: number | undefined;
  startDate?: Date | undefined;
  endDate?: Date | undefined;
}

export class CampaignByCodeRequest implements ICampaignByCodeRequest {
  dealerNo?: string | undefined;
  campaignCode?: string | undefined;

  constructor(data?: ICampaignByCodeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealerNo = _data["dealerNo"];
      this.campaignCode = _data["campaignCode"];
    }
  }

  static fromJS(data: any): CampaignByCodeRequest {
    data = typeof data === "object" ? data : {};
    let result = new CampaignByCodeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealerNo"] = this.dealerNo;
    data["campaignCode"] = this.campaignCode;
    return data;
  }
}

export interface ICampaignByCodeRequest {
  dealerNo?: string | undefined;
  campaignCode?: string | undefined;
}

export class DealerRequest implements IDealerRequest {
  dealerNoList?: string[] | undefined;
  workshopSystemFilter?: WorkshopSystemEnum[] | undefined;
  chassiNumber?: string | undefined;
  odometer?: number;

  constructor(data?: IDealerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["dealerNoList"])) {
        this.dealerNoList = [] as any;
        for (let item of _data["dealerNoList"]) this.dealerNoList!.push(item);
      }
      if (Array.isArray(_data["workshopSystemFilter"])) {
        this.workshopSystemFilter = [] as any;
        for (let item of _data["workshopSystemFilter"])
          this.workshopSystemFilter!.push(item);
      }
      this.chassiNumber = _data["chassiNumber"];
      this.odometer = _data["odometer"];
    }
  }

  static fromJS(data: any): DealerRequest {
    data = typeof data === "object" ? data : {};
    let result = new DealerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.dealerNoList)) {
      data["dealerNoList"] = [];
      for (let item of this.dealerNoList) data["dealerNoList"].push(item);
    }
    if (Array.isArray(this.workshopSystemFilter)) {
      data["workshopSystemFilter"] = [];
      for (let item of this.workshopSystemFilter)
        data["workshopSystemFilter"].push(item);
    }
    data["chassiNumber"] = this.chassiNumber;
    data["odometer"] = this.odometer;
    return data;
  }
}

export interface IDealerRequest {
  dealerNoList?: string[] | undefined;
  workshopSystemFilter?: WorkshopSystemEnum[] | undefined;
  chassiNumber?: string | undefined;
  odometer?: number;
}

export class ExternalTyreUrlRequest implements IExternalTyreUrlRequest {
  dealerNumber?: string | undefined;
  chassiNumber?: string | undefined;

  constructor(data?: IExternalTyreUrlRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealerNumber = _data["dealerNumber"];
      this.chassiNumber = _data["chassiNumber"];
    }
  }

  static fromJS(data: any): ExternalTyreUrlRequest {
    data = typeof data === "object" ? data : {};
    let result = new ExternalTyreUrlRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealerNumber"] = this.dealerNumber;
    data["chassiNumber"] = this.chassiNumber;
    return data;
  }
}

export interface IExternalTyreUrlRequest {
  dealerNumber?: string | undefined;
  chassiNumber?: string | undefined;
}

export class InsuranceCompanyRequest implements IInsuranceCompanyRequest {
  dealerNumber?: string | undefined;

  constructor(data?: IInsuranceCompanyRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealerNumber = _data["dealerNumber"];
    }
  }

  static fromJS(data: any): InsuranceCompanyRequest {
    data = typeof data === "object" ? data : {};
    let result = new InsuranceCompanyRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealerNumber"] = this.dealerNumber;
    return data;
  }
}

export interface IInsuranceCompanyRequest {
  dealerNumber?: string | undefined;
}

export class FilteredPackagesRequest implements IFilteredPackagesRequest {
  brand!: string | undefined;
  chassiNumber!: string | undefined;
  odometer!: number;
  dealerNumber!: string | undefined;
  ruleGroupList?: number[] | undefined;

  constructor(data?: IFilteredPackagesRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.brand = _data["brand"];
      this.chassiNumber = _data["chassiNumber"];
      this.odometer = _data["odometer"];
      this.dealerNumber = _data["dealerNumber"];
      if (Array.isArray(_data["ruleGroupList"])) {
        this.ruleGroupList = [] as any;
        for (let item of _data["ruleGroupList"]) this.ruleGroupList!.push(item);
      }
    }
  }

  static fromJS(data: any): FilteredPackagesRequest {
    data = typeof data === "object" ? data : {};
    let result = new FilteredPackagesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["brand"] = this.brand;
    data["chassiNumber"] = this.chassiNumber;
    data["odometer"] = this.odometer;
    data["dealerNumber"] = this.dealerNumber;
    if (Array.isArray(this.ruleGroupList)) {
      data["ruleGroupList"] = [];
      for (let item of this.ruleGroupList) data["ruleGroupList"].push(item);
    }
    return data;
  }
}

export interface IFilteredPackagesRequest {
  brand: string | undefined;
  chassiNumber: string | undefined;
  odometer: number;
  dealerNumber: string | undefined;
  ruleGroupList?: number[] | undefined;
}

export class PackageRequest implements IPackageRequest {
  chassiNumber?: string | undefined;
  odometer?: number;
  dealerNumber?: string | undefined;
  systems?: WorkshopSystemEnum[] | undefined;

  constructor(data?: IPackageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.chassiNumber = _data["chassiNumber"];
      this.odometer = _data["odometer"];
      this.dealerNumber = _data["dealerNumber"];
      if (Array.isArray(_data["systems"])) {
        this.systems = [] as any;
        for (let item of _data["systems"]) this.systems!.push(item);
      }
    }
  }

  static fromJS(data: any): PackageRequest {
    data = typeof data === "object" ? data : {};
    let result = new PackageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["chassiNumber"] = this.chassiNumber;
    data["odometer"] = this.odometer;
    data["dealerNumber"] = this.dealerNumber;
    if (Array.isArray(this.systems)) {
      data["systems"] = [];
      for (let item of this.systems) data["systems"].push(item);
    }
    return data;
  }
}

export interface IPackageRequest {
  chassiNumber?: string | undefined;
  odometer?: number;
  dealerNumber?: string | undefined;
  systems?: WorkshopSystemEnum[] | undefined;
}

export class RejectBusinessProposalRequest implements IRejectBusinessProposalRequest {
  proposalId!: string;
  rejectionReason!: BusinessProposalRejectionReasonEnum;
  comment?: string | undefined;

  constructor(data?: IRejectBusinessProposalRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.proposalId = _data["proposalId"];
      this.rejectionReason = _data["rejectionReason"];
      this.comment = _data["comment"];
    }
  }

  static fromJS(data: any): RejectBusinessProposalRequest {
    data = typeof data === "object" ? data : {};
    let result = new RejectBusinessProposalRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["proposalId"] = this.proposalId;
    data["rejectionReason"] = this.rejectionReason;
    data["comment"] = this.comment;
    return data;
  }
}

export interface IRejectBusinessProposalRequest {
  proposalId: string;
  rejectionReason: BusinessProposalRejectionReasonEnum;
  comment?: string | undefined;
}

export class SelectedPackagesRequest implements ISelectedPackagesRequest {
  packageId?: number | undefined;
  packageExternalId?: string | undefined;
  subPackageIds?: string[] | undefined;

  constructor(data?: ISelectedPackagesRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.packageId = _data["packageId"];
      this.packageExternalId = _data["packageExternalId"];
      if (Array.isArray(_data["subPackageIds"])) {
        this.subPackageIds = [] as any;
        for (let item of _data["subPackageIds"]) this.subPackageIds!.push(item);
      }
    }
  }

  static fromJS(data: any): SelectedPackagesRequest {
    data = typeof data === "object" ? data : {};
    let result = new SelectedPackagesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["packageId"] = this.packageId;
    data["packageExternalId"] = this.packageExternalId;
    if (Array.isArray(this.subPackageIds)) {
      data["subPackageIds"] = [];
      for (let item of this.subPackageIds) data["subPackageIds"].push(item);
    }
    return data;
  }
}

export interface ISelectedPackagesRequest {
  packageId?: number | undefined;
  packageExternalId?: string | undefined;
  subPackageIds?: string[] | undefined;
}

export class GetTechUpdateStatusRequest implements IGetTechUpdateStatusRequest {
  chassiNumber!: string;

  constructor(data?: IGetTechUpdateStatusRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.chassiNumber = _data["chassiNumber"];
    }
  }

  static fromJS(data: any): GetTechUpdateStatusRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetTechUpdateStatusRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["chassiNumber"] = this.chassiNumber;
    return data;
  }
}

export interface IGetTechUpdateStatusRequest {
  chassiNumber: string;
}

export class VehicleChassiRequest implements IVehicleChassiRequest {
  chassiNumber?: string | undefined;
  odometer?: number;

  constructor(data?: IVehicleChassiRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.chassiNumber = _data["chassiNumber"];
      this.odometer = _data["odometer"];
    }
  }

  static fromJS(data: any): VehicleChassiRequest {
    data = typeof data === "object" ? data : {};
    let result = new VehicleChassiRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["chassiNumber"] = this.chassiNumber;
    data["odometer"] = this.odometer;
    return data;
  }
}

export interface IVehicleChassiRequest {
  chassiNumber?: string | undefined;
  odometer?: number;
}

export class VehicleSearchRequest implements IVehicleSearchRequest {
  registrationNumber?: string | undefined;
  chassiNumber?: string | undefined;

  constructor(data?: IVehicleSearchRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.registrationNumber = _data["registrationNumber"];
      this.chassiNumber = _data["chassiNumber"];
    }
  }

  static fromJS(data: any): VehicleSearchRequest {
    data = typeof data === "object" ? data : {};
    let result = new VehicleSearchRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["registrationNumber"] = this.registrationNumber;
    data["chassiNumber"] = this.chassiNumber;
    return data;
  }
}

export interface IVehicleSearchRequest {
  registrationNumber?: string | undefined;
  chassiNumber?: string | undefined;
}

export class VehicleSegmentRequest implements IVehicleSegmentRequest {
  chassiNumber?: string | undefined;
  dealerNumber?: string | undefined;

  constructor(data?: IVehicleSegmentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.chassiNumber = _data["chassiNumber"];
      this.dealerNumber = _data["dealerNumber"];
    }
  }

  static fromJS(data: any): VehicleSegmentRequest {
    data = typeof data === "object" ? data : {};
    let result = new VehicleSegmentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["chassiNumber"] = this.chassiNumber;
    data["dealerNumber"] = this.dealerNumber;
    return data;
  }
}

export interface IVehicleSegmentRequest {
  chassiNumber?: string | undefined;
  dealerNumber?: string | undefined;
}

export class ActiveWorkshopSystemResponse implements IActiveWorkshopSystemResponse {
  workshopSystemId!: WorkshopSystemEnum;
  name?: string | undefined;
  shortDescription?: string | undefined;
  longDescription?: string | undefined;

  constructor(data?: IActiveWorkshopSystemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.workshopSystemId = _data["workshopSystemId"];
      this.name = _data["name"];
      this.shortDescription = _data["shortDescription"];
      this.longDescription = _data["longDescription"];
    }
  }

  static fromJS(data: any): ActiveWorkshopSystemResponse {
    data = typeof data === "object" ? data : {};
    let result = new ActiveWorkshopSystemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["workshopSystemId"] = this.workshopSystemId;
    data["name"] = this.name;
    data["shortDescription"] = this.shortDescription;
    data["longDescription"] = this.longDescription;
    return data;
  }
}

export interface IActiveWorkshopSystemResponse {
  workshopSystemId: WorkshopSystemEnum;
  name?: string | undefined;
  shortDescription?: string | undefined;
  longDescription?: string | undefined;
}

export class BusinessProposalResponse implements IBusinessProposalResponse {
  businessProposalId?: string;
  mileage?: number | undefined;
  packages?: PackageResponse[] | undefined;
  businessProposalStatus?: BusinessProposalStatusEnum;
  vehicle?: VehicleSearchResponse | undefined;
  dealer?: DealerResponse | undefined;
  workshopSystems?: ActiveWorkshopSystemResponse[] | undefined;
  customer?: CustomerResponse | undefined;
  businessProposalLeadId?: number | undefined;
  leadCreatedAt?: Date | undefined;

  constructor(data?: IBusinessProposalResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.businessProposalId = _data["businessProposalId"];
      this.mileage = _data["mileage"];
      if (Array.isArray(_data["packages"])) {
        this.packages = [] as any;
        for (let item of _data["packages"])
          this.packages!.push(PackageResponse.fromJS(item));
      }
      this.businessProposalStatus = _data["businessProposalStatus"];
      this.vehicle = _data["vehicle"]
        ? VehicleSearchResponse.fromJS(_data["vehicle"])
        : (undefined as any);
      this.dealer = _data["dealer"]
        ? DealerResponse.fromJS(_data["dealer"])
        : (undefined as any);
      if (Array.isArray(_data["workshopSystems"])) {
        this.workshopSystems = [] as any;
        for (let item of _data["workshopSystems"])
          this.workshopSystems!.push(ActiveWorkshopSystemResponse.fromJS(item));
      }
      this.customer = _data["customer"]
        ? CustomerResponse.fromJS(_data["customer"])
        : (undefined as any);
      this.businessProposalLeadId = _data["businessProposalLeadId"];
      this.leadCreatedAt = _data["leadCreatedAt"]
        ? new Date(_data["leadCreatedAt"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): BusinessProposalResponse {
    data = typeof data === "object" ? data : {};
    let result = new BusinessProposalResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["businessProposalId"] = this.businessProposalId;
    data["mileage"] = this.mileage;
    if (Array.isArray(this.packages)) {
      data["packages"] = [];
      for (let item of this.packages)
        data["packages"].push(item ? item.toJSON() : (undefined as any));
    }
    data["businessProposalStatus"] = this.businessProposalStatus;
    data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : (undefined as any);
    data["dealer"] = this.dealer ? this.dealer.toJSON() : (undefined as any);
    if (Array.isArray(this.workshopSystems)) {
      data["workshopSystems"] = [];
      for (let item of this.workshopSystems)
        data["workshopSystems"].push(item ? item.toJSON() : (undefined as any));
    }
    data["customer"] = this.customer
      ? this.customer.toJSON()
      : (undefined as any);
    data["businessProposalLeadId"] = this.businessProposalLeadId;
    data["leadCreatedAt"] = this.leadCreatedAt
      ? this.leadCreatedAt.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IBusinessProposalResponse {
  businessProposalId?: string;
  mileage?: number | undefined;
  packages?: PackageResponse[] | undefined;
  businessProposalStatus?: BusinessProposalStatusEnum;
  vehicle?: VehicleSearchResponse | undefined;
  dealer?: DealerResponse | undefined;
  workshopSystems?: ActiveWorkshopSystemResponse[] | undefined;
  customer?: CustomerResponse | undefined;
  businessProposalLeadId?: number | undefined;
  leadCreatedAt?: Date | undefined;
}

export class CalendarDayTimeSlotResponse implements ICalendarDayTimeSlotResponse {
  date?: Date;
  availableCalendarJobIds?: string[] | undefined;
  availableDropoffoptionIds?: string[] | undefined;
  timeSlots?: CalendarTimeSlotResponse[] | undefined;

  constructor(data?: ICalendarDayTimeSlotResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : (undefined as any);
      if (Array.isArray(_data["availableCalendarJobIds"])) {
        this.availableCalendarJobIds = [] as any;
        for (let item of _data["availableCalendarJobIds"])
          this.availableCalendarJobIds!.push(item);
      }
      if (Array.isArray(_data["availableDropoffoptionIds"])) {
        this.availableDropoffoptionIds = [] as any;
        for (let item of _data["availableDropoffoptionIds"])
          this.availableDropoffoptionIds!.push(item);
      }
      if (Array.isArray(_data["timeSlots"])) {
        this.timeSlots = [] as any;
        for (let item of _data["timeSlots"])
          this.timeSlots!.push(CalendarTimeSlotResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CalendarDayTimeSlotResponse {
    data = typeof data === "object" ? data : {};
    let result = new CalendarDayTimeSlotResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    if (Array.isArray(this.availableCalendarJobIds)) {
      data["availableCalendarJobIds"] = [];
      for (let item of this.availableCalendarJobIds)
        data["availableCalendarJobIds"].push(item);
    }
    if (Array.isArray(this.availableDropoffoptionIds)) {
      data["availableDropoffoptionIds"] = [];
      for (let item of this.availableDropoffoptionIds)
        data["availableDropoffoptionIds"].push(item);
    }
    if (Array.isArray(this.timeSlots)) {
      data["timeSlots"] = [];
      for (let item of this.timeSlots)
        data["timeSlots"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICalendarDayTimeSlotResponse {
  date?: Date;
  availableCalendarJobIds?: string[] | undefined;
  availableDropoffoptionIds?: string[] | undefined;
  timeSlots?: CalendarTimeSlotResponse[] | undefined;
}

export class CalendarTimeSlotResponse implements ICalendarTimeSlotResponse {
  slot?: string;
  mechanicDurations?: MechanicDurationResponse[] | undefined;

  constructor(data?: ICalendarTimeSlotResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.slot = _data["slot"];
      if (Array.isArray(_data["mechanicDurations"])) {
        this.mechanicDurations = [] as any;
        for (let item of _data["mechanicDurations"])
          this.mechanicDurations!.push(MechanicDurationResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CalendarTimeSlotResponse {
    data = typeof data === "object" ? data : {};
    let result = new CalendarTimeSlotResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["slot"] = this.slot;
    if (Array.isArray(this.mechanicDurations)) {
      data["mechanicDurations"] = [];
      for (let item of this.mechanicDurations)
        data["mechanicDurations"].push(
          item ? item.toJSON() : (undefined as any)
        );
    }
    return data;
  }
}

export interface ICalendarTimeSlotResponse {
  slot?: string;
  mechanicDurations?: MechanicDurationResponse[] | undefined;
}

export class MechanicDurationResponse implements IMechanicDurationResponse {
  mechanicId?: string | undefined;
  duration?: string;

  constructor(data?: IMechanicDurationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.mechanicId = _data["mechanicId"];
      this.duration = _data["duration"];
    }
  }

  static fromJS(data: any): MechanicDurationResponse {
    data = typeof data === "object" ? data : {};
    let result = new MechanicDurationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["mechanicId"] = this.mechanicId;
    data["duration"] = this.duration;
    return data;
  }
}

export interface IMechanicDurationResponse {
  mechanicId?: string | undefined;
  duration?: string;
}

export class CreateBookingErrorResponse implements ICreateBookingErrorResponse {
  bookingError?: BookingErrorEnum;
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: ICreateBookingErrorResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.bookingError = _data["bookingError"];
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): CreateBookingErrorResponse {
    data = typeof data === "object" ? data : {};
    let result = new CreateBookingErrorResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["bookingError"] = this.bookingError;
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface ICreateBookingErrorResponse {
  bookingError?: BookingErrorEnum;
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class CreateBookingResponse implements ICreateBookingResponse {
  orderId?: string | undefined;

  constructor(data?: ICreateBookingResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orderId = _data["orderId"];
    }
  }

  static fromJS(data: any): CreateBookingResponse {
    data = typeof data === "object" ? data : {};
    let result = new CreateBookingResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["orderId"] = this.orderId;
    return data;
  }
}

export interface ICreateBookingResponse {
  orderId?: string | undefined;
}

export class CustomerResponse implements ICustomerResponse {
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  sendSms?: boolean;

  constructor(data?: ICustomerResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phone = _data["phone"];
      this.email = _data["email"];
      this.sendSms = _data["sendSms"];
    }
  }

  static fromJS(data: any): CustomerResponse {
    data = typeof data === "object" ? data : {};
    let result = new CustomerResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phone"] = this.phone;
    data["email"] = this.email;
    data["sendSms"] = this.sendSms;
    return data;
  }
}

export interface ICustomerResponse {
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  sendSms?: boolean;
}

export class DealerOpenHourResponse implements IDealerOpenHourResponse {
  nameOfDay?: string | undefined;
  openTime?: string | undefined;
  closeTime?: string | undefined;
  closed?: boolean;
  dayOfWeek?: number;

  constructor(data?: IDealerOpenHourResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.nameOfDay = _data["nameOfDay"];
      this.openTime = _data["openTime"];
      this.closeTime = _data["closeTime"];
      this.closed = _data["closed"];
      this.dayOfWeek = _data["dayOfWeek"];
    }
  }

  static fromJS(data: any): DealerOpenHourResponse {
    data = typeof data === "object" ? data : {};
    let result = new DealerOpenHourResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["nameOfDay"] = this.nameOfDay;
    data["openTime"] = this.openTime;
    data["closeTime"] = this.closeTime;
    data["closed"] = this.closed;
    data["dayOfWeek"] = this.dayOfWeek;
    return data;
  }
}

export interface IDealerOpenHourResponse {
  nameOfDay?: string | undefined;
  openTime?: string | undefined;
  closeTime?: string | undefined;
  closed?: boolean;
  dayOfWeek?: number;
}

export class DealerResponse implements IDealerResponse {
  brandCode?: BrandCodeEnum;
  brandName?: string | undefined;
  number?: string | undefined;
  name?: string | undefined;
  email?: string | undefined;
  serviceBookingEmail?: string | undefined;
  phoneNumber?: string | undefined;
  url?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  zipCode?: string | undefined;
  longitude?: number;
  latitude?: number;
  dealerWorkshopSystemResponses?: DealerWorkshopSystemResponse[] | undefined;
  dealerOpenHourResponses?: DealerOpenHourResponse[] | undefined;
  searchServiceEnabled?: boolean;
  dealerProperties?: DealerPropertyResponse[] | undefined;
  whatsAppEnabled?: boolean;

  constructor(data?: IDealerResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.brandCode = _data["brandCode"];
      this.brandName = _data["brandName"];
      this.number = _data["number"];
      this.name = _data["name"];
      this.email = _data["email"];
      this.serviceBookingEmail = _data["serviceBookingEmail"];
      this.phoneNumber = _data["phoneNumber"];
      this.url = _data["url"];
      this.city = _data["city"];
      this.street = _data["street"];
      this.zipCode = _data["zipCode"];
      this.longitude = _data["longitude"];
      this.latitude = _data["latitude"];
      if (Array.isArray(_data["dealerWorkshopSystemResponses"])) {
        this.dealerWorkshopSystemResponses = [] as any;
        for (let item of _data["dealerWorkshopSystemResponses"])
          this.dealerWorkshopSystemResponses!.push(
            DealerWorkshopSystemResponse.fromJS(item)
          );
      }
      if (Array.isArray(_data["dealerOpenHourResponses"])) {
        this.dealerOpenHourResponses = [] as any;
        for (let item of _data["dealerOpenHourResponses"])
          this.dealerOpenHourResponses!.push(
            DealerOpenHourResponse.fromJS(item)
          );
      }
      this.searchServiceEnabled = _data["searchServiceEnabled"];
      if (Array.isArray(_data["dealerProperties"])) {
        this.dealerProperties = [] as any;
        for (let item of _data["dealerProperties"])
          this.dealerProperties!.push(DealerPropertyResponse.fromJS(item));
      }
      this.whatsAppEnabled = _data["whatsAppEnabled"];
    }
  }

  static fromJS(data: any): DealerResponse {
    data = typeof data === "object" ? data : {};
    let result = new DealerResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["brandCode"] = this.brandCode;
    data["brandName"] = this.brandName;
    data["number"] = this.number;
    data["name"] = this.name;
    data["email"] = this.email;
    data["serviceBookingEmail"] = this.serviceBookingEmail;
    data["phoneNumber"] = this.phoneNumber;
    data["url"] = this.url;
    data["city"] = this.city;
    data["street"] = this.street;
    data["zipCode"] = this.zipCode;
    data["longitude"] = this.longitude;
    data["latitude"] = this.latitude;
    if (Array.isArray(this.dealerWorkshopSystemResponses)) {
      data["dealerWorkshopSystemResponses"] = [];
      for (let item of this.dealerWorkshopSystemResponses)
        data["dealerWorkshopSystemResponses"].push(
          item ? item.toJSON() : (undefined as any)
        );
    }
    if (Array.isArray(this.dealerOpenHourResponses)) {
      data["dealerOpenHourResponses"] = [];
      for (let item of this.dealerOpenHourResponses)
        data["dealerOpenHourResponses"].push(
          item ? item.toJSON() : (undefined as any)
        );
    }
    data["searchServiceEnabled"] = this.searchServiceEnabled;
    if (Array.isArray(this.dealerProperties)) {
      data["dealerProperties"] = [];
      for (let item of this.dealerProperties)
        data["dealerProperties"].push(
          item ? item.toJSON() : (undefined as any)
        );
    }
    data["whatsAppEnabled"] = this.whatsAppEnabled;
    return data;
  }
}

export interface IDealerResponse {
  brandCode?: BrandCodeEnum;
  brandName?: string | undefined;
  number?: string | undefined;
  name?: string | undefined;
  email?: string | undefined;
  serviceBookingEmail?: string | undefined;
  phoneNumber?: string | undefined;
  url?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  zipCode?: string | undefined;
  longitude?: number;
  latitude?: number;
  dealerWorkshopSystemResponses?: DealerWorkshopSystemResponse[] | undefined;
  dealerOpenHourResponses?: DealerOpenHourResponse[] | undefined;
  searchServiceEnabled?: boolean;
  dealerProperties?: DealerPropertyResponse[] | undefined;
  whatsAppEnabled?: boolean;
}

export class DealerWorkshopSystemResponse implements IDealerWorkshopSystemResponse {
  workshopSystem?: WorkshopSystemEnum;
  daysUntilNextFreeTime?: number;
  firstAvailableTime?: Date;

  constructor(data?: IDealerWorkshopSystemResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.workshopSystem = _data["workshopSystem"];
      this.daysUntilNextFreeTime = _data["daysUntilNextFreeTime"];
      this.firstAvailableTime = _data["firstAvailableTime"]
        ? new Date(_data["firstAvailableTime"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): DealerWorkshopSystemResponse {
    data = typeof data === "object" ? data : {};
    let result = new DealerWorkshopSystemResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["workshopSystem"] = this.workshopSystem;
    data["daysUntilNextFreeTime"] = this.daysUntilNextFreeTime;
    data["firstAvailableTime"] = this.firstAvailableTime
      ? this.firstAvailableTime.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IDealerWorkshopSystemResponse {
  workshopSystem?: WorkshopSystemEnum;
  daysUntilNextFreeTime?: number;
  firstAvailableTime?: Date;
}

export class DescriptionResponse implements IDescriptionResponse {
  dealerNo?: string | undefined;
  brand?: BrandCodeEnum | undefined;
  header?: string | undefined;
  shortDescription?: string | undefined;
  longDescription?: string | undefined;

  constructor(data?: IDescriptionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealerNo = _data["dealerNo"];
      this.brand = _data["brand"];
      this.header = _data["header"];
      this.shortDescription = _data["shortDescription"];
      this.longDescription = _data["longDescription"];
    }
  }

  static fromJS(data: any): DescriptionResponse {
    data = typeof data === "object" ? data : {};
    let result = new DescriptionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealerNo"] = this.dealerNo;
    data["brand"] = this.brand;
    data["header"] = this.header;
    data["shortDescription"] = this.shortDescription;
    data["longDescription"] = this.longDescription;
    return data;
  }
}

export interface IDescriptionResponse {
  dealerNo?: string | undefined;
  brand?: BrandCodeEnum | undefined;
  header?: string | undefined;
  shortDescription?: string | undefined;
  longDescription?: string | undefined;
}

export class EbuCarModelResponse implements IEbuCarModelResponse {
  groupID!: string | undefined;
  groupName!: string | undefined;
  sipp!: string | undefined;
  imageURL?: string | undefined;
  rateCode!: string | undefined;
  previewValue!: number;
  priceExVat!: number;
  readonly priceIncVat?: number;
  currency!: string | undefined;
  kmsIncluded!: boolean;
  kmsFreePerDay!: number;
  description?: string | undefined;
  brand?: string | undefined;
  model?: string | undefined;
  fuel?: string | undefined;
  seats?: number | undefined;
  doors?: number | undefined;
  automaticTransmission?: boolean | undefined;
  suitcases?: number | undefined;
  handbag?: number | undefined;
  minAge?: number | undefined;
  maxAge?: number | undefined;
  specialGroup?: boolean | undefined;
  groupOrderToShow?: number | undefined;
  capacity?: number | undefined;
  load?: number | undefined;
  maxLength?: number | undefined;
  minWidth?: number | undefined;
  maxWidth?: number | undefined;
  height?: number | undefined;
  category?: string | undefined;
  segment?: number | undefined;
  segmentDescription?: string | undefined;
  chassiType?: string | undefined;
  powerHP?: number | undefined;
  powerKW?: number | undefined;
  co2?: number | undefined;

  constructor(data?: IEbuCarModelResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.groupID = _data["groupID"];
      this.groupName = _data["groupName"];
      this.sipp = _data["sipp"];
      this.imageURL = _data["imageURL"];
      this.rateCode = _data["rateCode"];
      this.previewValue = _data["previewValue"];
      this.priceExVat = _data["priceExVat"];
      (this as any).priceIncVat = _data["priceIncVat"];
      this.currency = _data["currency"];
      this.kmsIncluded = _data["kmsIncluded"];
      this.kmsFreePerDay = _data["kmsFreePerDay"];
      this.description = _data["description"];
      this.brand = _data["brand"];
      this.model = _data["model"];
      this.fuel = _data["fuel"];
      this.seats = _data["seats"];
      this.doors = _data["doors"];
      this.automaticTransmission = _data["automaticTransmission"];
      this.suitcases = _data["suitcases"];
      this.handbag = _data["handbag"];
      this.minAge = _data["minAge"];
      this.maxAge = _data["maxAge"];
      this.specialGroup = _data["specialGroup"];
      this.groupOrderToShow = _data["groupOrderToShow"];
      this.capacity = _data["capacity"];
      this.load = _data["load"];
      this.maxLength = _data["maxLength"];
      this.minWidth = _data["minWidth"];
      this.maxWidth = _data["maxWidth"];
      this.height = _data["height"];
      this.category = _data["category"];
      this.segment = _data["segment"];
      this.segmentDescription = _data["segmentDescription"];
      this.chassiType = _data["chassiType"];
      this.powerHP = _data["powerHP"];
      this.powerKW = _data["powerKW"];
      this.co2 = _data["co2"];
    }
  }

  static fromJS(data: any): EbuCarModelResponse {
    data = typeof data === "object" ? data : {};
    let result = new EbuCarModelResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["groupID"] = this.groupID;
    data["groupName"] = this.groupName;
    data["sipp"] = this.sipp;
    data["imageURL"] = this.imageURL;
    data["rateCode"] = this.rateCode;
    data["previewValue"] = this.previewValue;
    data["priceExVat"] = this.priceExVat;
    data["priceIncVat"] = this.priceIncVat;
    data["currency"] = this.currency;
    data["kmsIncluded"] = this.kmsIncluded;
    data["kmsFreePerDay"] = this.kmsFreePerDay;
    data["description"] = this.description;
    data["brand"] = this.brand;
    data["model"] = this.model;
    data["fuel"] = this.fuel;
    data["seats"] = this.seats;
    data["doors"] = this.doors;
    data["automaticTransmission"] = this.automaticTransmission;
    data["suitcases"] = this.suitcases;
    data["handbag"] = this.handbag;
    data["minAge"] = this.minAge;
    data["maxAge"] = this.maxAge;
    data["specialGroup"] = this.specialGroup;
    data["groupOrderToShow"] = this.groupOrderToShow;
    data["capacity"] = this.capacity;
    data["load"] = this.load;
    data["maxLength"] = this.maxLength;
    data["minWidth"] = this.minWidth;
    data["maxWidth"] = this.maxWidth;
    data["height"] = this.height;
    data["category"] = this.category;
    data["segment"] = this.segment;
    data["segmentDescription"] = this.segmentDescription;
    data["chassiType"] = this.chassiType;
    data["powerHP"] = this.powerHP;
    data["powerKW"] = this.powerKW;
    data["co2"] = this.co2;
    return data;
  }
}

export interface IEbuCarModelResponse {
  groupID: string | undefined;
  groupName: string | undefined;
  sipp: string | undefined;
  imageURL?: string | undefined;
  rateCode: string | undefined;
  previewValue: number;
  priceExVat: number;
  priceIncVat?: number;
  currency: string | undefined;
  kmsIncluded: boolean;
  kmsFreePerDay: number;
  description?: string | undefined;
  brand?: string | undefined;
  model?: string | undefined;
  fuel?: string | undefined;
  seats?: number | undefined;
  doors?: number | undefined;
  automaticTransmission?: boolean | undefined;
  suitcases?: number | undefined;
  handbag?: number | undefined;
  minAge?: number | undefined;
  maxAge?: number | undefined;
  specialGroup?: boolean | undefined;
  groupOrderToShow?: number | undefined;
  capacity?: number | undefined;
  load?: number | undefined;
  maxLength?: number | undefined;
  minWidth?: number | undefined;
  maxWidth?: number | undefined;
  height?: number | undefined;
  category?: string | undefined;
  segment?: number | undefined;
  segmentDescription?: string | undefined;
  chassiType?: string | undefined;
  powerHP?: number | undefined;
  powerKW?: number | undefined;
  co2?: number | undefined;
}

export class ExternalTyreUrlResponse implements IExternalTyreUrlResponse {
  externalTyreUrl?: string | undefined;

  constructor(data?: IExternalTyreUrlResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.externalTyreUrl = _data["externalTyreUrl"];
    }
  }

  static fromJS(data: any): ExternalTyreUrlResponse {
    data = typeof data === "object" ? data : {};
    let result = new ExternalTyreUrlResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["externalTyreUrl"] = this.externalTyreUrl;
    return data;
  }
}

export interface IExternalTyreUrlResponse {
  externalTyreUrl?: string | undefined;
}

export class InsuranceCompanyResponse implements IInsuranceCompanyResponse {
  insuranceCompanyId?: number;
  name?: string | undefined;
  description?: string | undefined;
  sortOrder?: number | undefined;

  constructor(data?: IInsuranceCompanyResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.insuranceCompanyId = _data["insuranceCompanyId"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.sortOrder = _data["sortOrder"];
    }
  }

  static fromJS(data: any): InsuranceCompanyResponse {
    data = typeof data === "object" ? data : {};
    let result = new InsuranceCompanyResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["insuranceCompanyId"] = this.insuranceCompanyId;
    data["name"] = this.name;
    data["description"] = this.description;
    data["sortOrder"] = this.sortOrder;
    return data;
  }
}

export interface IInsuranceCompanyResponse {
  insuranceCompanyId?: number;
  name?: string | undefined;
  description?: string | undefined;
  sortOrder?: number | undefined;
}

export class PackageResponse implements IPackageResponse {
  id?: string | undefined;
  name?: string | undefined;
  dealerNo?: string | undefined;
  description?: DescriptionResponse | undefined;
  tags?: PackageTagEnum[] | undefined;
  price?: PriceResponse | undefined;
  subPackages?: PackageResponse[] | undefined;
  type?: PackageTypeEnum;
  durationHours?: number;
  priority?: number;
  packageExternalId?: string | undefined;
  properties?: PropertyEnum[] | undefined;
  isSubCategory?: boolean;
  recallCodes?: string[] | undefined;

  constructor(data?: IPackageResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.dealerNo = _data["dealerNo"];
      this.description = _data["description"]
        ? DescriptionResponse.fromJS(_data["description"])
        : (undefined as any);
      if (Array.isArray(_data["tags"])) {
        this.tags = [] as any;
        for (let item of _data["tags"]) this.tags!.push(item);
      }
      this.price = _data["price"]
        ? PriceResponse.fromJS(_data["price"])
        : (undefined as any);
      if (Array.isArray(_data["subPackages"])) {
        this.subPackages = [] as any;
        for (let item of _data["subPackages"])
          this.subPackages!.push(PackageResponse.fromJS(item));
      }
      this.type = _data["type"];
      this.durationHours = _data["durationHours"];
      this.priority = _data["priority"];
      this.packageExternalId = _data["packageExternalId"];
      if (Array.isArray(_data["properties"])) {
        this.properties = [] as any;
        for (let item of _data["properties"]) this.properties!.push(item);
      }
      this.isSubCategory = _data["isSubCategory"];
      if (Array.isArray(_data["recallCodes"])) {
        this.recallCodes = [] as any;
        for (let item of _data["recallCodes"]) this.recallCodes!.push(item);
      }
    }
  }

  static fromJS(data: any): PackageResponse {
    data = typeof data === "object" ? data : {};
    let result = new PackageResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["dealerNo"] = this.dealerNo;
    data["description"] = this.description
      ? this.description.toJSON()
      : (undefined as any);
    if (Array.isArray(this.tags)) {
      data["tags"] = [];
      for (let item of this.tags) data["tags"].push(item);
    }
    data["price"] = this.price ? this.price.toJSON() : (undefined as any);
    if (Array.isArray(this.subPackages)) {
      data["subPackages"] = [];
      for (let item of this.subPackages)
        data["subPackages"].push(item ? item.toJSON() : (undefined as any));
    }
    data["type"] = this.type;
    data["durationHours"] = this.durationHours;
    data["priority"] = this.priority;
    data["packageExternalId"] = this.packageExternalId;
    if (Array.isArray(this.properties)) {
      data["properties"] = [];
      for (let item of this.properties) data["properties"].push(item);
    }
    data["isSubCategory"] = this.isSubCategory;
    if (Array.isArray(this.recallCodes)) {
      data["recallCodes"] = [];
      for (let item of this.recallCodes) data["recallCodes"].push(item);
    }
    return data;
  }
}

export interface IPackageResponse {
  id?: string | undefined;
  name?: string | undefined;
  dealerNo?: string | undefined;
  description?: DescriptionResponse | undefined;
  tags?: PackageTagEnum[] | undefined;
  price?: PriceResponse | undefined;
  subPackages?: PackageResponse[] | undefined;
  type?: PackageTypeEnum;
  durationHours?: number;
  priority?: number;
  packageExternalId?: string | undefined;
  properties?: PropertyEnum[] | undefined;
  isSubCategory?: boolean;
  recallCodes?: string[] | undefined;
}

export class PriceResponse implements IPriceResponse {
  dealerNo?: string | undefined;
  brand?: BrandCodeEnum | undefined;
  price?: number | undefined;
  priceNoVat?: number | undefined;
  discounted?: number | undefined;
  discountedNoVat?: number | undefined;
  type?: PriceTypeEnum;

  constructor(data?: IPriceResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealerNo = _data["dealerNo"];
      this.brand = _data["brand"];
      this.price = _data["price"];
      this.priceNoVat = _data["priceNoVat"];
      this.discounted = _data["discounted"];
      this.discountedNoVat = _data["discountedNoVat"];
      this.type = _data["type"];
    }
  }

  static fromJS(data: any): PriceResponse {
    data = typeof data === "object" ? data : {};
    let result = new PriceResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealerNo"] = this.dealerNo;
    data["brand"] = this.brand;
    data["price"] = this.price;
    data["priceNoVat"] = this.priceNoVat;
    data["discounted"] = this.discounted;
    data["discountedNoVat"] = this.discountedNoVat;
    data["type"] = this.type;
    return data;
  }
}

export interface IPriceResponse {
  dealerNo?: string | undefined;
  brand?: BrandCodeEnum | undefined;
  price?: number | undefined;
  priceNoVat?: number | undefined;
  discounted?: number | undefined;
  discountedNoVat?: number | undefined;
  type?: PriceTypeEnum;
}

export class GetTechUpdateStatusResponse implements IGetTechUpdateStatusResponse {
  readonly successfulRecallCheck?: boolean;
  readonly hasPassiveTechUpdate?: boolean;
  readonly hasActiveTechUpdate?: boolean;

  constructor(data?: IGetTechUpdateStatusResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (this as any).successfulRecallCheck = _data["successfulRecallCheck"];
      (this as any).hasPassiveTechUpdate = _data["hasPassiveTechUpdate"];
      (this as any).hasActiveTechUpdate = _data["hasActiveTechUpdate"];
    }
  }

  static fromJS(data: any): GetTechUpdateStatusResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetTechUpdateStatusResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["successfulRecallCheck"] = this.successfulRecallCheck;
    data["hasPassiveTechUpdate"] = this.hasPassiveTechUpdate;
    data["hasActiveTechUpdate"] = this.hasActiveTechUpdate;
    return data;
  }
}

export interface IGetTechUpdateStatusResponse {
  successfulRecallCheck?: boolean;
  hasPassiveTechUpdate?: boolean;
  hasActiveTechUpdate?: boolean;
}

export class ServiceAgreementResponse implements IServiceAgreementResponse {
  isSuccess?: boolean;
  data?: VehicleServiceAgreementResponse | undefined;

  constructor(data?: IServiceAgreementResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isSuccess = _data["isSuccess"];
      this.data = _data["data"]
        ? VehicleServiceAgreementResponse.fromJS(_data["data"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): ServiceAgreementResponse {
    data = typeof data === "object" ? data : {};
    let result = new ServiceAgreementResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["isSuccess"] = this.isSuccess;
    data["data"] = this.data ? this.data.toJSON() : (undefined as any);
    return data;
  }
}

export interface IServiceAgreementResponse {
  isSuccess?: boolean;
  data?: VehicleServiceAgreementResponse | undefined;
}

export class VehicleSearchResponse implements IVehicleSearchResponse {
  registrationNumber?: string | undefined;
  chassiNumber?: string | undefined;
  brandName?: string | undefined;
  brandCode?: BrandCodeEnum;
  hasServiceAgreement?: boolean;
  serviceAgreementResponse!: ServiceAgreementResponse | undefined;
  modelVariantName?: string | undefined;
  modelYear?: number;
  isCompanyVehicle?: boolean;
  specialBrandCode?: string | undefined;
  fuelType?: string | undefined;
  originalVehicleSegment?: number;

  constructor(data?: IVehicleSearchResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.registrationNumber = _data["registrationNumber"];
      this.chassiNumber = _data["chassiNumber"];
      this.brandName = _data["brandName"];
      this.brandCode = _data["brandCode"];
      this.hasServiceAgreement = _data["hasServiceAgreement"];
      this.serviceAgreementResponse = _data["serviceAgreementResponse"]
        ? ServiceAgreementResponse.fromJS(_data["serviceAgreementResponse"])
        : (undefined as any);
      this.modelVariantName = _data["modelVariantName"];
      this.modelYear = _data["modelYear"];
      this.isCompanyVehicle = _data["isCompanyVehicle"];
      this.specialBrandCode = _data["specialBrandCode"];
      this.fuelType = _data["fuelType"];
      this.originalVehicleSegment = _data["originalVehicleSegment"];
    }
  }

  static fromJS(data: any): VehicleSearchResponse {
    data = typeof data === "object" ? data : {};
    let result = new VehicleSearchResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["registrationNumber"] = this.registrationNumber;
    data["chassiNumber"] = this.chassiNumber;
    data["brandName"] = this.brandName;
    data["brandCode"] = this.brandCode;
    data["hasServiceAgreement"] = this.hasServiceAgreement;
    data["serviceAgreementResponse"] = this.serviceAgreementResponse
      ? this.serviceAgreementResponse.toJSON()
      : (undefined as any);
    data["modelVariantName"] = this.modelVariantName;
    data["modelYear"] = this.modelYear;
    data["isCompanyVehicle"] = this.isCompanyVehicle;
    data["specialBrandCode"] = this.specialBrandCode;
    data["fuelType"] = this.fuelType;
    data["originalVehicleSegment"] = this.originalVehicleSegment;
    return data;
  }
}

export interface IVehicleSearchResponse {
  registrationNumber?: string | undefined;
  chassiNumber?: string | undefined;
  brandName?: string | undefined;
  brandCode?: BrandCodeEnum;
  hasServiceAgreement?: boolean;
  serviceAgreementResponse: ServiceAgreementResponse | undefined;
  modelVariantName?: string | undefined;
  modelYear?: number;
  isCompanyVehicle?: boolean;
  specialBrandCode?: string | undefined;
  fuelType?: string | undefined;
  originalVehicleSegment?: number;
}

export class VehicleServiceAgreementResponse implements IVehicleServiceAgreementResponse {
  validTo?: Date | undefined;
  mileageValidTo?: number | undefined;
  dealerAgreement?: boolean;
  validDealers?: string[] | undefined;

  constructor(data?: IVehicleServiceAgreementResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.validTo = _data["validTo"]
        ? new Date(_data["validTo"].toString())
        : (undefined as any);
      this.mileageValidTo = _data["mileageValidTo"];
      this.dealerAgreement = _data["dealerAgreement"];
      if (Array.isArray(_data["validDealers"])) {
        this.validDealers = [] as any;
        for (let item of _data["validDealers"]) this.validDealers!.push(item);
      }
    }
  }

  static fromJS(data: any): VehicleServiceAgreementResponse {
    data = typeof data === "object" ? data : {};
    let result = new VehicleServiceAgreementResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["validTo"] = this.validTo
      ? this.validTo.toISOString()
      : (undefined as any);
    data["mileageValidTo"] = this.mileageValidTo;
    data["dealerAgreement"] = this.dealerAgreement;
    if (Array.isArray(this.validDealers)) {
      data["validDealers"] = [];
      for (let item of this.validDealers) data["validDealers"].push(item);
    }
    return data;
  }
}

export interface IVehicleServiceAgreementResponse {
  validTo?: Date | undefined;
  mileageValidTo?: number | undefined;
  dealerAgreement?: boolean;
  validDealers?: string[] | undefined;
}

export class VehicleWarningLightsResponse implements IVehicleWarningLightsResponse {
  warningLightId?: number;
  name?: string | undefined;
  description?: string | undefined;
  imageURL?: string | undefined;

  constructor(data?: IVehicleWarningLightsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.warningLightId = _data["warningLightId"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.imageURL = _data["imageURL"];
    }
  }

  static fromJS(data: any): VehicleWarningLightsResponse {
    data = typeof data === "object" ? data : {};
    let result = new VehicleWarningLightsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["warningLightId"] = this.warningLightId;
    data["name"] = this.name;
    data["description"] = this.description;
    data["imageURL"] = this.imageURL;
    return data;
  }
}

export interface IVehicleWarningLightsResponse {
  warningLightId?: number;
  name?: string | undefined;
  description?: string | undefined;
  imageURL?: string | undefined;
}

export class FindBookingsV2Request implements IFindBookingsV2Request {
  dealerNumber?: string | undefined;
  chassiNumber?: string | undefined;
  earliestStartTime?: Date;

  constructor(data?: IFindBookingsV2Request) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dealerNumber = _data["dealerNumber"];
      this.chassiNumber = _data["chassiNumber"];
      this.earliestStartTime = _data["earliestStartTime"]
        ? new Date(_data["earliestStartTime"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): FindBookingsV2Request {
    data = typeof data === "object" ? data : {};
    let result = new FindBookingsV2Request();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dealerNumber"] = this.dealerNumber;
    data["chassiNumber"] = this.chassiNumber;
    data["earliestStartTime"] = this.earliestStartTime
      ? this.earliestStartTime.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IFindBookingsV2Request {
  dealerNumber?: string | undefined;
  chassiNumber?: string | undefined;
  earliestStartTime?: Date;
}

export class FindBookingV2Response implements IFindBookingV2Response {
  id?: string | undefined;
  systemId?: string | undefined;
  chassiNumber?: string | undefined;
  dealerNumber?: string | undefined;
  bookingType?: BookingTypeEnum;
  created?: Date;
  time?: Date;
  workshopSystems?: WorkshopSystemEnum[] | undefined;

  constructor(data?: IFindBookingV2Response) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.systemId = _data["systemId"];
      this.chassiNumber = _data["chassiNumber"];
      this.dealerNumber = _data["dealerNumber"];
      this.bookingType = _data["bookingType"];
      this.created = _data["created"]
        ? new Date(_data["created"].toString())
        : (undefined as any);
      this.time = _data["time"]
        ? new Date(_data["time"].toString())
        : (undefined as any);
      if (Array.isArray(_data["workshopSystems"])) {
        this.workshopSystems = [] as any;
        for (let item of _data["workshopSystems"])
          this.workshopSystems!.push(item);
      }
    }
  }

  static fromJS(data: any): FindBookingV2Response {
    data = typeof data === "object" ? data : {};
    let result = new FindBookingV2Response();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["systemId"] = this.systemId;
    data["chassiNumber"] = this.chassiNumber;
    data["dealerNumber"] = this.dealerNumber;
    data["bookingType"] = this.bookingType;
    data["created"] = this.created
      ? this.created.toISOString()
      : (undefined as any);
    data["time"] = this.time ? this.time.toISOString() : (undefined as any);
    if (Array.isArray(this.workshopSystems)) {
      data["workshopSystems"] = [];
      for (let item of this.workshopSystems) data["workshopSystems"].push(item);
    }
    return data;
  }
}

export interface IFindBookingV2Response {
  id?: string | undefined;
  systemId?: string | undefined;
  chassiNumber?: string | undefined;
  dealerNumber?: string | undefined;
  bookingType?: BookingTypeEnum;
  created?: Date;
  time?: Date;
  workshopSystems?: WorkshopSystemEnum[] | undefined;
}

export enum BookingErrorEnum {
  SelectedDayUnavailable = "SelectedDayUnavailable",
  NoTimeSlotFoundForTimeSlotBooking = "NoTimeSlotFoundForTimeSlotBooking",
  NoDropoffOptionSelected = "NoDropoffOptionSelected",
  SelectedDropoffOptionIsNotAvailableThatDay = "SelectedDropoffOptionIsNotAvailableThatDay",
  SelectedTimeUnavailable = "SelectedTimeUnavailable"
}

export enum PackageTagEnum {
  Service = "Service",
  Recommended = "Recommended",
  MainPackage = "MainPackage",
  Removable = "Removable",
  Campaign = "Campaign",
  Economy = "Economy",
  PPS = "PPS",
  ServiceHistoryWarning = "ServiceHistoryWarning",
  ServiceAgreement = "ServiceAgreement"
}

export enum BookingTypeEnum {
  Direct = "Direct",
  BusinessProposal = "BusinessProposal"
}

export enum BrandCodeEnum {
  A = "A",
  V = "V",
  S = "S",
  C = "C",
  N = "N",
  P = "P"
}

export enum BusinessProposalRejectionReasonEnum {
  CustomerDoesNotWantAnAppointment = "CustomerDoesNotWantAnAppointment",
  CustomerUsingOtherPartner = "CustomerUsingOtherPartner",
  CustomerNoLongerInPossessionOfTheVehicle = "CustomerNoLongerInPossessionOfTheVehicle",
  CustomerNotInterestedRevisit = "CustomerNotInterestedRevisit",
  Other = "Other",
  VehicleInvalidForService = "VehicleInvalidForService"
}

export enum BusinessProposalStatusEnum {
  Pending = "Pending",
  Created = "Created",
  Sent = "Sent",
  Booked = "Booked",
  Inactive = "Inactive",
  Expired = "Expired",
  Rejected = "Rejected",
  AcceptedWithoutBooking = "AcceptedWithoutBooking",
  InvalidForService = "InvalidForService"
}

export enum CampaignTypeEnum {
  Package = "Package",
  Code = "Code"
}

export enum DealerPropertyEnum {
  Restaurant = "Restaurant",
  Gym = "Gym",
  MRF = "MRF",
  Recond = "Recond",
  MachineWash = "MachineWash",
  Europcar = "Europcar",
  ExternalTyreBooking = "ExternalTyreBooking"
}

export enum DealerPropertyGroupEnum {
  OtherSettings = "OtherSettings",
  AdditionalServices = "AdditionalServices"
}

export enum DealerPropertyTypeEnum {
  String = "String",
  Url = "Url"
}

export enum DiscountTypeEnum {
  Fixed = "Fixed",
  Percentage = "Percentage"
}

export enum PackageTypeEnum {
  OriginalService = "OriginalService",
  BaseService = "BaseService",
  Windshield = "Windshield",
  Wheel = "Wheel",
  Troubleshooting = "Troubleshooting",
  DropoffOption = "DropoffOption",
  DealerExtra = "DealerExtra",
  PPS = "PPS",
  ServiceAdditional = "ServiceAdditional",
  WashAndRecond = "WashAndRecond",
  Mobility = "Mobility",
  TechUpdate = "TechUpdate",
  CheckInOption = "CheckInOption",
  Other = "Other",
  ServiceLink = "ServiceLink"
}

export enum PriceTypeEnum {
  Free = "Free",
  Fixed = "Fixed",
  From = "From",
  Offer = "Offer",
  Deductibles = "Deductibles",
  Calculated = "Calculated",
  Litre = "Litre"
}

export enum PropertyEnum {
  Recommended = "Recommended",
  EveningShift = "EveningShift",
  Required = "Required",
  TimeSlot = "TimeSlot",
  WindscreenRepair = "WindscreenRepair",
  WindscreenReplacement = "WindscreenReplacement",
  PorscheOriginalService = "PorscheOriginalService",
  DropoffDayBefore = "DropoffDayBefore",
  DropoffMorning = "DropoffMorning",
  EuropcarDropoff = "EuropcarDropoff"
}

export enum WorkshopSystemEnum {
  Service = "Service",
  Wheel = "Wheel",
  Windscreen = "Windscreen",
  Troubleshooting = "Troubleshooting",
  TechUpdate = "TechUpdate",
  Other = "Other"
}

export class ApplicationMessageResponse implements IApplicationMessageResponse {
  applicationMessageId?: number;
  applicationTypeId?: ApplicationTypeEnum;
  applicationMessageTypeId?: ApplicationMessageTypeEnum;
  isActive?: boolean;
  message?: string | undefined;

  constructor(data?: IApplicationMessageResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.applicationMessageId = _data["applicationMessageId"];
      this.applicationTypeId = _data["applicationTypeId"];
      this.applicationMessageTypeId = _data["applicationMessageTypeId"];
      this.isActive = _data["isActive"];
      this.message = _data["message"];
    }
  }

  static fromJS(data: any): ApplicationMessageResponse {
    data = typeof data === "object" ? data : {};
    let result = new ApplicationMessageResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["applicationMessageId"] = this.applicationMessageId;
    data["applicationTypeId"] = this.applicationTypeId;
    data["applicationMessageTypeId"] = this.applicationMessageTypeId;
    data["isActive"] = this.isActive;
    data["message"] = this.message;
    return data;
  }
}

export interface IApplicationMessageResponse {
  applicationMessageId?: number;
  applicationTypeId?: ApplicationTypeEnum;
  applicationMessageTypeId?: ApplicationMessageTypeEnum;
  isActive?: boolean;
  message?: string | undefined;
}

export enum ApplicationMessageTypeEnum {
  Info = "Info",
  Warning = "Warning",
  Danger = "Danger"
}

export enum ApplicationTypeEnum {
  TBO = "TBO",
  VBO = "VBO"
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new SwaggerException(message, status, response, headers, null);
}
